import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { News } from '../components/News';
import { Footer } from '../components/Footer';
export function NewsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-neutral-light" data-id="element-862">
      <Header data-id="element-863" />
      <main className="pt-20 pb-16" data-id="element-864">
        <News data-id="element-865" />
      </main>
      <Footer data-id="element-866" />
    </div>;
}